import styled, { css } from "styled-components";

export const Sticky = styled.div<{ position?: 'top' | 'bottom' }>`
    position: sticky;
    ${(props) => props.position === 'top' && css`
        top: 0; 
        padding-top: 16px;
    `}

    ${(props) => props.position === 'bottom' && css`
        bottom: 0; 
        padding-top: 32px;
        padding-bottom: 16px;
        margin-bottom: -16px;
        background: linear-gradient(rgba(251, 251, 254, 0), #fcfcfe 16px);
    `}
`;
